<template>
    <div class="experience safe-distance-top">
        <div class="experience_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">职称经历</div>
            <div class="determine" @click="determine">提交</div>
        </div>
        <div class="experience_bottom">
            <van-field
                v-model="title"
                rows="2"
                autosize
                type="textarea"
                maxlength="500"
                placeholder="请输入个人职称经历"
                show-word-limit
                ref="input"
            />
        </div>
    </div>
</template>

<script>
import { Toast } from "vant";
export default {
    name: "experience",
    data() {
        return {
            title: "",
            // 教育背景 6
            experienceId: "",
        };
    },
    created() {
        this.experienceId = this.$route.query.experienceId;
        // 回显
        this.title = JSON.parse(sessionStorage.getItem("experiencecontent"));
        // 聚焦
        this.$nextTick(() => {
            this.$refs.input.focus();
        });
    },
    methods: {
        to() {
            window.history.go(-1);
        },
        determine() {
            if (this.title == "") {
                Toast("不能为空");
            } else {
                this.addOrEditExperience();
                window.history.go(-1);
            }
        },
        // 保存提交
        async addOrEditExperience() {
            let res = await this.$apis.userServe.addOrEditExperience({
                content: this.title,
                id: this.experienceId,
                type: 7,
            });
            if (res.data.resultCode == 200) {
                Toast("提交成功");
            } else {
                Toast(res.data.resultDesc);
            }
            console.log("是否成功?", res);
        },
    },
};
</script>

<style lang="scss" scoped>
.experience {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .experience_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
        align-content: center;
        position: relative;

        .my {
            width: 100px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #fff;
            align-content: center;
        }

        .determine {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            position: absolute;
            right: 15px;
        }
    }

    .experience_bottom {
        width: 94%;
        margin: 12px auto;
        border-radius: 8px;

        .van-field {
            border-radius: 8px;
        }
    }
}
</style>
